import store from '../../store'
import { getSodaGlobalParams } from '@/common/utils/bridge'
import { getOSInfo } from '@/common/utils/env'
import { getBDCountry } from './i18n'
import storage from 'didi-store'
let isPro = process.env.NODE_ENV === 'production'
const OS_TYPE_JSON = {
  window: 9,
  mac: 10,
  android: 2,
  ios: 1,
  default: -1
}

function IsPC () {
  var userAgentInfo = navigator.userAgent
  var Agents = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod'
  ]
  var flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

export async function getUserName () {
  const userInfo = store.state.login.userInfo || {}
  const userName = userInfo.username || storage.get('uname') || ''
  return userName
}

const isPCFlag = IsPC()
export async function trackEvent (eventId, attrs) {
  const userInfo = store.state.login.userInfo || {}
  const userName = userInfo.username || storage.get('uname') || ''
  const geo = store.state.geo || {}
  const areaGroup = store.getters.areaGroup || {}
  let globalParams = {}
  try {
    globalParams = await getSodaGlobalParams()
  } catch (e) {
    // console.warn('can\'t find getSodaGlobalParams')
  }
  let version = globalParams.appVersion
  const user = {
    name: userName,
    email: userInfo.email || '',
    dept: userInfo.dept || '',
    job: userInfo.job || '',
    locale: userInfo.locale || '',
    country: userInfo.country || '',
    userName: userName
  }
  const attachInfo = {
    // 设备和业务信息 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=272905834
    osType: OS_TYPE_JSON[getOSInfo() || 'default'],
    businessType: 4, // 内部业务类型 1:r, 2:c, 3:b, 4:bd, 5:m
    brand: 2, // 外卖品牌类型 1:滴滴外卖，2:didi Food，3:99 Food
    terminalType: 1 // 端类型信息 1：独立端 5：web
  }
  window.Omega.setUserName(userName)
  // 控制台报已经删除该api
  // window.Omega.setLocation(geo.lng, geo.lat)
  window.Omega.setCityId(areaGroup.cityId)
  window.Omega.setConfig({
    locale: userInfo.locale,
    countyId: userInfo.country || getBDCountry(),
    userName: userName,
    userId: userName,
    attrs: {
      explorer: version ? 1 : isPCFlag ? 0 : 2
    }
  })
  if (window.Omega&& isPro) {
    // 增加描述，兼容天眼埋点
    window.Omega.trackEvent(eventId, `发送Omega埋点: ${eventId}`, {
      terminal: 'app',
      appVersion: version || '',
      country: userInfo.country || getBDCountry(),
      user,
      ...attachInfo,
      ...attrs,
      explorer: version ? 1 : isPCFlag ? 0 : 2
    })
  }
}
